import styled from "styled-components"
import { ReactComponent as LinkIcon } from "images/icons/link-horizontal.svg"
import { ReactComponent as ChevronDownIcon } from "images/icons/chevron-down.svg"
import { ReactComponent as ChevronUpIcon } from "images/icons/chevron-up.svg"

export const Container = styled.div`
  border: 0.1rem solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 0.75rem;
  position: relative;
  left: -1rem;
  width: 100%;
  margin: 0.2rem 0;
`

export const Line = styled.div`
  width: 0.1rem;
  height: 2rem;
  background: ${({ theme }) => theme.colors.borderLight};
  margin-left: 1rem;
  ${(p) => p.theme.mQ.MEDIA_MIN_MEDIUM} {
    margin-left: 2rem;
  }
`

export const Trigger = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 1rem;
  display: flex;
  align-items: center;
  border-radius: 0.75rem;
  font-size: 1.3rem;
  cursor: pointer;
  transition: background 0.2s;
  user-select: none;

  &:hover {
    background: ${({ theme }) => theme.colors.background};
  }
`

export const TriggerLabel = styled.span`
  flex: 1;
  color: ${({ theme }) => theme.colors.greyDarker};
`

export const ChevronDown = styled(ChevronDownIcon)`
  height: 1.4rem;
  width: 1.4rem;
  fill: ${({ theme }) => theme.colors.greyDarker};
`

export const ChevronUp = styled(ChevronUpIcon)`
  height: 1.4rem;
  width: 1.4rem;
  fill: ${({ theme }) => theme.colors.greyDarker};
`

export const SearchWrapper = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  font-size: 1.3rem;
  border-top: 0.1rem solid ${({ theme }) => theme.colors.borderLight};

  > div:last-child {
    margin-bottom: 0;
    max-width: none;
    flex: 1;
  }
`

export const CustomStateIcon = styled(LinkIcon)`
  height: 2rem;
  width: 2rem;
  fill: ${({ theme }) => theme.colors.blue};
`

export const IconWrapper = styled.div`
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
  border-radius: 50%;
  border: 0.1rem solid ${({ theme }) => theme.colors.blue};
  background: ${({ theme }) => theme.colors.blueLight};
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StateList = styled.div`
  max-height: 30rem;
  overflow-y: auto;
  padding: 0.5rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 0 0 0.75rem 0.75rem;
`

export const NoResults = styled.div`
  padding: 1.5rem;
  text-align: center;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.greyDarker};
`

export const StateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 0.8rem;
  border-radius: 0.6rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.borderLight};
  flex-wrap: wrap;

  > button:last-child {
    margin-left: auto;
  }
`

export const StateRowName = styled.span`
  font-weight: 600;
  font-size: 1.2rem;
  white-space: nowrap;
`

export const StateRowOperations = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
`

export const StateRowOperationTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.1rem 0.5rem;
  border-radius: 0.3rem;
  background: ${({ theme }) => theme.colors.background};
  border: 0.1rem solid ${({ theme }) => theme.colors.borderLight};
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.greyDarker};
  white-space: nowrap;

  svg {
    width: 0.8rem;
    height: 0.8rem;
    fill: ${({ theme }) => theme.colors.greyDarker};
  }
`
